export default __webpack_public_path__ + "static/media/privilege-9.bfe351de.svg";